'use client'

import { Button } from '@sushiswap/ui'
import React, { type FC } from 'react'
import type { UseEvmTradeReturn } from 'src/lib/hooks/react-query'
import { type Amount, ZERO } from 'sushi'

export const ConfirmSwapButton: FC<{
  confirm: () => void
  trade: UseEvmTradeReturn | undefined
  token0Symbol?: string
  token1Symbol?: string
  isWrap: boolean
  isUnwrap: boolean
  isSwapQueryError: boolean
  isWritePending: boolean
  swapAmount: Amount<any> | undefined
  showPriceImpactWarning: boolean
  showSlippageWarning: boolean
  write?: (confirm: () => void) => Promise<void>
}> = ({
  confirm,
  token0Symbol,
  token1Symbol,
  isWrap,
  isUnwrap,
  isSwapQueryError,
  isWritePending,
  swapAmount,
  showPriceImpactWarning,
  showSlippageWarning,
  write,
}) => {
  const disabled = Boolean(
    isWritePending ||
      Boolean(!write && swapAmount?.gt(ZERO)) ||
      isSwapQueryError,
  )

  return (
    <div className="flex flex-col gap-4 w-full">
      <Button
        fullWidth
        size="xl"
        loading={!write && !isSwapQueryError}
        onClick={() => write?.(confirm)}
        disabled={disabled}
        color={
          isSwapQueryError || showPriceImpactWarning || showSlippageWarning
            ? 'red'
            : 'blue'
        }
        testId="confirm-swap"
      >
        {isSwapQueryError
          ? 'Shoot! Something went wrong :('
          : isWrap
            ? 'Wrap'
            : isUnwrap
              ? 'Unwrap'
              : `Swap ${token0Symbol} for ${token1Symbol}`}
      </Button>
    </div>
  )
}
